import React from 'react';
import { useSelector } from 'react-redux';

export default function ExecutiveSummarySection({
  getValueByKey,
  renderMarkdown = () => {},
  isBlackBookUrl = false,
  generateTable,
  divisionData,
  getValueForKey,
}) {
  const { displayUserConfig } = useSelector(({ fundData }) => fundData);

  const sectionsConfig =
    displayUserConfig?.data?.ic_report_ui_config?.sections || [];

  const executiveSection = sectionsConfig?.find(
    (section) => section?.key === 'executive_summary'
  );

  const sectionTitle = executiveSection?.title;

  const allClientKeys =
    displayUserConfig?.data?.client_ui_config?.sections
      ?.flatMap((section) => section.values || [])
      ?.map((item) => item.key) || [];

  const alwaysIncludeKeys = [
    'key_person_list',
    'management_fee',
    'fundraising_status',
  ];

  const filteredFields =
    executiveSection?.values?.filter(
      (field) =>
        field?.key &&
        (allClientKeys?.includes(field.key) ||
          alwaysIncludeKeys.includes(field.key))
    ) || [];

  const textClass = isBlackBookUrl
    ? 'text-14-executive'
    : 'web-typography-mini-executive';
  const spanClass = isBlackBookUrl ? 'web-span-mini-14' : 'web-span-mini';

  const keyPersons =
    divisionData?.portfolioTeam
      ?.map(
        (person) =>
          `${getValueForKey(person, 'first_name')} ${getValueForKey(
            person,
            'last_name'
          )}`
      )
      .join(', ') || '';

  const renderField = ({ key, title }) => {
    const value = getValueByKey(key);

    console.log('hasBothValue ', key, value);
    if (key === 'size') {
      const maxSize = getValueByKey('max_fund_size');
      const hasBothValue = value && maxSize;

      return (
        <p key={key} className={textClass}>
          {title}:{' '}
          <span className={spanClass}>
            {renderMarkdown(value)} {renderMarkdown(maxSize)}{' '}
            {hasBothValue && 'max'}
          </span>
        </p>
      );
    }

    if (key === 'management_fee') {
      return (
        <div key={key} className="mb-3">
          {generateTable(divisionData?.fundFees)}
        </div>
      );
    }

    if (key === 'key_person_list') {
      return (
        <p key={key} className={textClass}>
          {title}: <span className={spanClass}>{keyPersons}</span>
        </p>
      );
    }

    if (key === 'fundraising_status') {
      return (
        <p key={key} className={textClass}>
          {title}:
        </p>
      );
    }

    const hasValue = value !== null && value !== undefined && value !== '';

    return (
      <p key={key} className={textClass}>
        {title}:{' '}
        <span className={spanClass}>
          {hasValue ? renderMarkdown(value) : ''}
        </span>
      </p>
    );
  };

  return (
    <>
      <div className="fund-wrap-web m-2 mt-2 p-3">
        <p className="web-header">{sectionTitle}</p>
      </div>

      <div className="fund-wrap-content m-2 mt-2 p-3">
        <div className="d-flex justify-content-between align-items-center">
          <div className="recomandation-content" style={{ gap: '16px' }}>
            {filteredFields?.length > 0 ? (
              filteredFields.map(renderField)
            ) : (
              <p className="web-span"></p>
            )}
          </div>
        </div>
      </div>
    </>
  );
}
